import { createSlice } from "@reduxjs/toolkit";
import configDb from "../config";
import Utils from "../utils";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    value: Utils.loginDetail() || null,
  },
  reducers: {
    login(state, action) {
      state.value = action.payload;
    },
    logout(state) {
      state.value = null;
      localStorage.removeItem(configDb.login_data);
    },
  },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;